export default __webpack_public_path__ + "static/media/facebook-grey.b6c7dc55.svg";